module.exports = __webpack_public_path__ + "static/img/result_error.c22a489b.png";